import type { GetExternalFeedbackResponse, JsonObject } from '@/app-package';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type GetFeedbackOptions = { dashboardId: string; appointmentId: string };

export type ExternalFeedback = JsonObject<GetExternalFeedbackResponse>;

const getExternalFeedback = async ({
  dashboardId,
  appointmentId,
}: GetFeedbackOptions) => {
  const config: AxiosRequestConfig = {
    url: `/external/dash/${dashboardId}/feedback/${appointmentId}`,
    method: 'get',
  };

  const { data } = await axios.request<ExternalFeedback>(config);

  return data;
};

export default getExternalFeedback;
